import { ApiClient } from '@webapp/core/services/ApiClient'
import { ExternalBankAccountRepository } from './ExternalBankAccountRepository'

export const externalBankAccountRepository = new ExternalBankAccountRepository({
  httpClient: ApiClient,
})
